









import { defineComponent, computed } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'CTABladeContainer',
  props: {
    variant: {
      type: Object,
    },
  },
  setup(props) {
    const ctaBladeBackground = computed(() => {
      if (Object.keys(props.variant!).includes('backgroundImage')) {
        return `bg-purple-gradient-image bg-cover bg-no-repeat bg-center`;
      }

      if (Object.keys(props.variant!).includes('backgroundColor')) {
        return `${props.variant!.backgroundColor}`;
      }
    });

    return {
      ctaBladeBackground,
    };
  },
});
